import Cookies from 'js-cookie';

// eslint-disable-next-line import/no-unused-modules
export const getCookie = Cookies.get;
export const setCookie = Cookies.set;
